import { Component, OnInit, HostListener, ElementRef, ViewChild, ViewChildren } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { JsonService } from '../_services/json.service';

@Component({
  selector: 'app-image-alone',
  templateUrl: './image-alone.component.html',
  styleUrl: './image-alone.component.scss'
})
export class ImageAloneComponent implements OnInit {

  imagemUrl: SafeUrl | null = null;
  public blobImage: any = 'loading.gif';
  public id: string = '';
  public rotationAngle: number = 0;
  zoom = 1;
  maxZoom = 3;
  minZoom = 0.8;
  @ViewChild('imageContainer', { static: true }) imageContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('image') image!: ElementRef;

  private isDragging = false;
  private startX = 0;
  private startY = 0;
  private currentX = 0;
  private currentY = 0;


  constructor(
    private jsonService: JsonService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.loadImage();

    window.addEventListener('storage', (event) => {
      if (event.key === 'prescriptionId') {
        const novoValor = event.newValue;
        if (novoValor != this.id && novoValor) {
          this.rotationAngle = -90;
          this.rotateImage();
          this.resetZoom();
          this.blobImage = 'loading.gif';
          this.getImageBlob();
        }
      }
    });
  }

  private loadImage(): void {
    this.getImageBlob();
  }

  private getImageBlob() {
    const prescriptionId = localStorage.getItem('prescriptionId');
    this.id = prescriptionId || '';
    
    this.jsonService.getImageItem(prescriptionId).subscribe(blob => {
      const objectUrl = URL.createObjectURL(blob);
      this.blobImage = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
    }, error => {
      console.error('Erro ao carregar imagem', error);
    });
  }

  

  zoomIn() {
    if (this.zoom < this.maxZoom) {
      this.zoom += 0.1;
    }
  } 
  zoomOut() {
    if (this.zoom > this.minZoom) {
      this.zoom -= 0.1;
    }
  }

  rotateImage() {
    const imageEl = this.image.nativeElement;
    this.rotationAngle = (this.rotationAngle + 90) % 360;
    imageEl.style.transform = `rotate(${this.rotationAngle}deg)`;
  }

  

  startDrag(event: MouseEvent) {
    event.preventDefault();
    this.isDragging = true;
    this.startX = event.clientX - this.currentX;
    this.startY = event.clientY - this.currentY;

    document.addEventListener('mousemove', this.onDrag);
    document.addEventListener('mouseup', this.endDrag);
  }

  onDrag = (event: MouseEvent) => {
    event.preventDefault();
    if (!this.isDragging) return;

    this.currentX = event.clientX - this.startX;
    this.currentY = event.clientY - this.startY;

    const imageEl = this.image.nativeElement;
    const containerEl = this.imageContainer.nativeElement;
    
    const maxY = imageEl.clientHeight - 50;
    const minY = 0 - imageEl.clientHeight + 50;
    const maxX = imageEl.clientWidth - 50;
    const minX = 0 - imageEl.clientWidth + 50;

    if(this.currentX > maxX){
      this.currentX = maxX;
    }
    if(this.currentX < minX){
      this.currentX = minX;
    }

    if(this.currentY > maxY){
      this.currentY = maxY;
    }
    if(this.currentY < minY){
      this.currentY = minY;
    }

    //imageEl.style.transform = `translate(${this.currentX}px, ${this.currentY}px)`;
    
    imageEl.style.transform = `translate(${this.currentX}px, ${this.currentY}px) rotate(${this.rotationAngle}deg)`;
  };

  endDrag = () => {
    this.isDragging = false;
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.endDrag);
  };

  resetZoom() {
    this.zoom = 1;
    this.imageContainer.nativeElement.style.transform = `scale(${this.zoom})`;
    this.currentX = 0;
    this.currentY = 0;
    const imageEl = this.image.nativeElement;
    imageEl.style.transform = `translate(0px, 0px)`;
  }

  
  
  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (!event.altKey) return;
    event.preventDefault();
    switch (event.key) {
      case '+': this.zoomIn(); break;
      case '=': this.zoomIn(); break;
      case '-': this.zoomOut(); break;
      case '_': this.zoomOut(); break;
      case 'R': case 'r': this.rotateImage(); break;
      case 'ArrowUp': event.preventDefault();this.triggerButton('ArrowUp'); break;
      case 'ArrowDown': event.preventDefault();this.triggerButton('ArrowDown'); break;
      case 'ArrowLeft': event.preventDefault();this.triggerButton('ArrowLeft'); break;
      case 'ArrowRight': event.preventDefault();this.triggerButton('ArrowRight'); break;
    }
  }
  

  triggerButton(buttonId: string) {
    const imageEl = this.image.nativeElement;
    
    switch (buttonId) {
      case 'ArrowUp':
        this.currentY -= 10;
        break;
      case 'ArrowDown':
        this.currentY += 10;
        break;
      case 'ArrowLeft':
        this.currentX -= 10;
        break;
      case 'ArrowRight':
        this.currentX += 10;
        break;
    }
    imageEl.style.transform = `translate(${this.currentX}px, ${this.currentY}px) rotate(${this.rotationAngle}deg)`;
  }
}
